<template>
  <div class="emptyList pa-3" justify="center" align="center">
    <div v-if="state && state.type == 'loading'">
      <v-progress-circular :size="50" :width="7" color="purple" indeterminate></v-progress-circular>
      <div class="mt-2">{{ state.message }}</div>
    </div>
    <div v-else-if="state && state.type == 'error'">
      <v-img class="emptybox" src="../../assets/images/emptybox.png" alt="errorList"  />
      <div class="mt-2 error--text">{{ state.message }}</div>
    </div>
    <div v-else>
      <v-img class="emptybox" src="../../assets/images/emptybox.png" alt="emptyList" />
      <div class="mt-2">{{ $t("emptyList") }}</div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    state: { type: Object }
  }
};
</script>

<style scoped>
.emptybox {
  width: 10%;
  min-width: 70px;
  filter: brightness(0.6) invert(0.6);
}
</style>